<template lang="pug">
.time-bar
  .progress
    .step-dot
      .step-dot-content(:style="`left:${ Math.min(step, 100) }%;`")
    .progress-content(:style="`width:${ Math.min(step, 100) }%;`")
    .step-text
      span(v-for="item in barData" :key="item.id") {{item.label}}
    .tiem-text
      span(v-for="item in barData" :key="item.id") {{item.value}}
</template>

<script>
export default {
  name: 'TimeBar',
  props: {
    barData: Array
  },
  data() {
    return {
      step: 0,
      startFlag: true,
      endFlag: true
    }
  },
  mounted() {
    setTimeout(() => {
      this.barData.forEach((item, i, arr) => {
        if (item.id === 'nowDate') {
          if (arr.length === 3) this.step = 50 * 1
          else if (arr.length === 2) this.step = 50 * 2
        }
      })
    }, 300)
  }
}
</script>

<style lang="stylus" scoped>
  .time-bar
    display flex
    justify-content center
    color $light-text-color
    font-size .86rem
    padding 2.14rem 0
    .progress
      position relative
      width 100%
      height 4px
      border-radius 10px
      background-color #f2f2f2
      .progress-content
        position absolute
        top 0
        left 0
        height 100%
        border-radius 10px
        background-color $theme-color
        transition width 500ms
      .step-text
        margin-top .71rem
        display flex
        justify-content space-between
      .tiem-text
        position absolute
        top -1.79rem
        width 100%
        display flex
        justify-content space-between
        font-size 1rem
        font-weight bold
      .step-dot
        display flex
        justify-content space-between
        position relative;
        .step-dot-content
          display inline-block
          width .71rem
          height .71rem
          background $theme-color
          border-radius 50%
          transition all 500ms
          position relative
          transform translate(-50%,-30%)
</style>
